exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#iubenda{background-color:#eee}a{color:green}.center{margin-top:100px}#iubenda-cs-banner{bottom:0!important;left:0!important;position:fixed!important;width:100%!important;z-index:99999998!important;background-color:#000}.iubenda-cs-content{display:block;margin:0 auto;padding:20px;width:auto;font-size:14px;background:#444;color:#fff}.iubenda-cs-rationale{max-width:900px;position:relative;margin:0 auto}.iubenda-banner-content>p{line-height:1.5}.iubenda-cs-close-btn{margin:0;color:#fff;text-decoration:none;font-size:20px;position:absolute;top:0;right:0;border:none}.iubenda-cs-cookie-policy-lnk{text-decoration:underline;color:#fff;font-size:14px;font-weight:900}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!./cookie.css
 ** module id = 353
 ** module chunks = 0
 **/